import * as TIME       from './TimeEnums';
import * as FORMATTING from './FormatStringEnums';
import * as UI         from './UIEnums';
import * as FORMS      from './FormEnums';
import * as SYSTEM     from './SystemEnums';
import * as EVENTS     from './EventsEnums';
import * as PRODUCT    from './ProductEnums';
import { CONTEXTS }    from './ContextEnums';

export * from './TimeEnums';
export * from './FormatStringEnums';
export * from './UIEnums';
export * from './FormEnums';
export * from './SystemEnums';
export * from './EventsEnums';
export * from './ProductEnums';
export * from './ContextEnums';
export const CONSTANTS = {
    SYSTEM,
    PRODUCT,
    FORMATTING,
    FORMS,
    TIME,
    UI,
    CONTEXTS,
    EVENTS,
};
